// extracted by mini-css-extract-plugin
export default {"delete":"DeleteBtn_delete__CH+K5"};